import Table from 'components/commons/table'
import { TABLE_WISHLIST } from 'configs/user/user-detail/configTableWishlist'

export const TabWishlist = ({ dataList, query, onChangeQuery, isLoading }) => {
    return (
        <div className={'flex flex-col px-9 py-4'}>
            <Table
                className={'my-3'}
                name={TABLE_WISHLIST.name}
                columns={TABLE_WISHLIST.column}
                data={dataList?.results}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onChangePage={(val) => onChangeQuery({ page: val })}
                loading={isLoading}
            />
        </div>
    )
}
